import getTabCategoryBgColor from '../utils/getTabCategoryBgColor';
import updateRootStyles from '../utils/updateRootStyles';

export default function prependFaqPagePreview(settings, widgetSetting) {
  const styleProperties = [
    'backgroundPage', // --faq-page-background-page
    'headerColor', // --faq-page-header-color
    'subtitleColor', // --faq-page-subtitle-color
    'bodyTextColor', // --faq-page-body-text-color
    'descriptionColor', // --faq-page-description-color
    'categoryColor', // --faq-page-category-color
    'questionTextColor', // --faq-page-question-text-color
    'questionBackgroundColor', // --faq-page-question-background-color
    'answerTextColor', // --faq-page-answer-text-color
    'answerBackgroundColor' // --faq-page-answer-background-color
  ];

  const cssRules = {};

  styleProperties.forEach(property => {
    const settingValue = settings[property];
    if (settingValue) {
      const propertyName =
        '--faq-page-' + property.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
      cssRules[propertyName] = settingValue;
    }
  });

  if (settings.questionBackgroundColor) {
    const tabCategoryBgColor = getTabCategoryBgColor(settings.questionBackgroundColor);
    cssRules['--faq-page-tab-category-background-color'] = tabCategoryBgColor[0];
    cssRules['--faq-page-tab-category-hover-color'] = tabCategoryBgColor[1];
  }

  if (widgetSetting.contentTextFont) {
    cssRules['--faq-page-font-family'] = widgetSetting.contentTextFont.replace(/\+/g, ' ');
  }

  updateRootStyles(cssRules);
}
